import { effects } from 'redux-saga'

export default function* logoutSaga(sso, setHref) {
  const logoutUrl = yield effects.call(sso.getLogoutUrl)

  yield effects.call(setHref, logoutUrl)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/logout.js